var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ValidationProvider', {
    staticClass: "form-group w-full",
    class: _vm.$attrs.class,
    attrs: {
      "mode": _vm.customValidate,
      "rules": _vm.rules,
      "tag": "div"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var errors = _ref.errors,
          classes = _ref.classes;
        return [_vm.label ? _c('label', {
          staticClass: "block text-base font-normal mb-1",
          class: _vm.labelClass
        }, [_vm._v(" " + _vm._s(_vm.label) + " "), _vm.isRequired ? _c('b', {
          staticClass: "ml-1 text-red-600 font-bold"
        }, [_vm._v("*")]) : _vm._e()]) : _vm._e(), _c('div', {
          staticClass: "relative input-group"
        }, [_c('LSelect', _vm._g({
          attrs: {
            "absolute-class": _vm.absoluteClass,
            "alwaysShowMenu": _vm.alwaysShowMenu,
            "close-on-select": _vm.closeOnSelect,
            "disabled": _vm.disabled,
            "hidden-input": _vm.hiddenInput,
            "loading": _vm.isLoading,
            "local-search": !_vm.search,
            "multiple": _vm.multiple,
            "options": _vm.items,
            "placeholder": _vm.placeholder
          },
          on: {
            "onOpen": _vm.onOpen,
            "onScrollEnd": _vm.onScrollEnd,
            "onSearchChange": _vm.onSearch
          },
          scopedSlots: _vm._u([_vm._l(_vm.$scopedSlots, function (_, slotName) {
            return {
              key: slotName,
              fn: function (_ref2) {
                var data = _ref2.data;
                return [_vm._t(slotName, null, {
                  "data": data
                })];
              }
            };
          }), {
            key: "option-content",
            fn: function (_ref3) {
              var data = _ref3.data;
              return [_vm._t("option-content", null, {
                "data": data
              })];
            }
          }], null, true),
          model: {
            value: _vm.dropdownValue,
            callback: function ($$v) {
              _vm.dropdownValue = $$v;
            },
            expression: "dropdownValue"
          }
        }, _vm.$listeners))], 1)];
      }
    }])
  });

}
var staticRenderFns = []

export { render, staticRenderFns }